import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Counter } from '../Counter';
import { img, site } from '../../data/site';
const facts = [{
  to: 1200,
  suffix: '+',
  label: 'Voertuigen behandeld'
}, {
  to: 4.9,
  decimals: 1,
  label: 'Gemiddelde beoordeling'
}, {
  to: 2,
  suffix: '+ jaar',
  label: 'Coating bescherming'
}];
export function Hero() {
  return <section className="relative isolate min-h-[92svh] overflow-hidden" data-id="element-566" data-mp="apv26wazgmp6">
      <img src={img.hero} alt="Een zilvergrijze hatchback vers gedetailleerd in de werkplaats van Daily Car Care" className="absolute inset-0 h-full w-full object-cover" data-id="element-567" data-mp="5ofib7kjkm8d" />
      <div className="absolute inset-0 bg-[linear-gradient(to_top,#08090a_6%,rgba(8,9,10,0.35)_55%,rgba(8,9,10,0.7)_100%)]" aria-hidden="true" data-id="element-568" data-mp="3rxys4q8dxzmf" />

      <div className="relative mx-auto flex min-h-[92svh] max-w-shell flex-col justify-end px-5 pb-28 pt-24 sm:px-6 lg:px-10 lg:pb-16 lg:pt-32" data-id="element-569" data-mp="1q4shco3mpbjf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-570" data-mp="1murjisedqc5k">
          <span className="flex items-center gap-3" data-id="element-571" data-mp="1czgckw97q98d">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-572" data-mp="1hx9ido6lt184" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-573" data-mp="1hxhu3cqzq0hq">
              Detailingstudio · {site.city}
            </span>
          </span>

          <h1 className="mt-6 max-w-3xl font-display text-[2.3rem] font-extrabold leading-[1.02] tracking-tightest text-chalk sm:text-5xl lg:text-[3.6rem]" data-id="element-574" data-mp="2am6qiyh3phn5">
            Waar de wasstraat stopt, <span className="text-ember" data-id="element-575" data-mp="20vlqd6ls4524">beginnen wij.</span>
          </h1>

          <div className="mt-8 flex flex-col gap-7 lg:flex-row lg:items-end lg:justify-between" data-id="element-576" data-mp="2ologvia1p2ym">
            <p className="max-w-md text-[15px] leading-relaxed text-chalk/70" data-id="element-577" data-mp="2ojvb0579amro">
              Interieurreiniging, showroombehandelingen en lakcorrectie voor alledaagse auto's — op afspraak, online
              geboekt in minder dan een minuut.
            </p>

            <div className="flex flex-wrap items-center gap-3" data-id="element-578" data-mp="2y9trbauepo8f">
              <Link to="/book" className="group inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3.5 text-sm font-semibold text-void transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-white hover:glow" data-id="element-579" data-mp="2u7745n8okrhk">
                Afspraak maken
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-580" data-mp="2fhrg4f0jb05k" />
              </Link>
              <a href={site.phoneHref} className="rounded-full border border-chalk/20 px-6 py-3.5 text-sm font-medium text-chalk transition-colors duration-200 ease-smooth hover:border-ember hover:text-ember" data-id="element-581" data-mp="26jpb7odojnd0">
                {site.phone}
              </a>
            </div>
          </div>

          <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-chalk/10 pt-7" data-id="element-582" data-mp="h10gi3rdk58j">
            {facts.map(f => <div key={f.label} data-id="element-583" data-mp="lzk7wjoqm98a">
                <dt className="sr-only" data-id="element-584" data-mp="m0li6lxxiroy">{f.label}</dt>
                <dd data-id="element-585" data-mp="q1f4xbzmy0g9">
                  <Counter to={f.to} decimals={f.decimals} suffix={f.suffix} className="block font-display text-2xl font-extrabold tracking-tight text-chalk sm:text-3xl" data-id="element-586" data-mp="q0nl0yfehr5t" />
                  <span className="mt-1.5 block text-[11px] uppercase tracking-[0.16em] text-dim" data-id="element-587" data-mp="2ccq0bwdylpg">{f.label}</span>
                </dd>
              </div>)}
          </dl>
        </motion.div>
      </div>
    </section>;
}